import { SET_AVOID_SEGMENT_GEOMETRY } from 'actions';

const defaultAvoidSegmentGeometriesState = {};

export default (state = defaultAvoidSegmentGeometriesState, { payload = {}, type }) => {
  switch (type) {
    case SET_AVOID_SEGMENT_GEOMETRY: {
      if (!payload.id || !payload.coordinates) return state;
      return { ...state, [payload.id]: payload.coordinates };
    }
    default:
      return state;
  }
};
